import { buildTextdomain } from 'react-gettext';
import Localization from '@dealersites/core/translations/Localization';

const i18n = (global.i18n = global.i18n || {});
const DS_MAPS_TEXT_DOMAIN = 'dealersite-maps';

const translations = {
  en: buildTextdomain(require('./en.json')),
  fr: buildTextdomain(require('./fr.json')),
};

const mapsLocalization = new Localization(translations, DS_MAPS_TEXT_DOMAIN);
i18n.maps = mapsLocalization;

export { mapsLocalization, translations, DS_MAPS_TEXT_DOMAIN };
